import { StandBase } from './standBase';
import { UnitConverter } from '../../core/utils/unitConverter';

const SIZES = {
	'cart': { width: 0.56, depth: 0.87, icon: '/static/img/icons/cart-black.svg' },
	'weigher': { width: 0.3, depth: 0.35, icon: '/static/img/icons/weigher-black.svg' },
	'enter': { width: 0.6, depth: 0.6, icon: '/static/img/icons/enter-black.svg' },
	'exit': { width: 0.6, depth: 0.6, icon: '/static/img/icons/exit-black.svg' },
	'door': { width: 0.6, depth: 0.6, icon: '/static/img/icons/door-black.png' },
	'window': { width: 0.6, depth: 0.1, icon: '/static/img/icons/window-black.png' },
	'shop-terminal': { width: 3.55, depth: 1.04, icon: '/static/img/icons/instrument-black.png' },
	'cash-terminal': { width: 0.55, depth: 0.42, icon: '/static/img/icons/cash-terminal-black.svg' }
};

export class Instrument extends StandBase {
	icon: string;
	type: string;
	id: number = null;
	terminalId: number = null;
	image: HTMLImageElement;
	created_at: string;
	updated_at: string;
	client_updated_at: string;

	constructor(x: number, y: number, type: string, width?: number, depth?: number, angle?: number, name?: string) {
		super(x, y, width, depth, angle, name);

		this.type = type;
		if (width != null) this.width = width; else this.width = UnitConverter.convertAndRoundToSaveValue(SIZES[this.type].width);
		if (depth != null) this.depth = depth; else this.depth = UnitConverter.convertAndRoundToSaveValue(SIZES[this.type].depth);
		this.icon = SIZES[this.type].icon;
		if (name != null) this.name = name; else this.name = '';
		if (angle != null) this.angle = angle; else this.angle = 0;
	}

	copy(): Instrument {
		const i = new Instrument(this.x, this.y, this.type, this.width, this.depth, this.angle, this.name);
		i.id = this.id;
		i.terminalId = this.terminalId;
		i.image = this.image;
		i.client_updated_at = this.client_updated_at;
		return i;
	}

	isEqual(instrument: Instrument): boolean {
		if (instrument.width != this.width) return false;
		if (instrument.depth != this.depth) return false;
		if (instrument.x != this.x) return false;
		if (instrument.y != this.y) return false;
		if (instrument.name != this.name) return false;
		if (instrument.angle != this.angle) return false;
		if (instrument.terminalId != this.terminalId) return false;

		return true;
	}
}